/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Customer_LabelInputs */

const en_ticket_customer_label = /** @type {(inputs: Ticket_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer:`)
};

const ja_ticket_customer_label = /** @type {(inputs: Ticket_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客:`)
};

const fr_ticket_customer_label = /** @type {(inputs: Ticket_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client :`)
};

const de_ticket_customer_label = /** @type {(inputs: Ticket_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde:`)
};

/**
* | output |
* | --- |
* | "Customer:" |
*
* @param {Ticket_Customer_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_customer_label = /** @type {((inputs?: Ticket_Customer_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Customer_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_customer_label(inputs)
	if (locale === "ja") return ja_ticket_customer_label(inputs)
	if (locale === "fr") return fr_ticket_customer_label(inputs)
	return de_ticket_customer_label(inputs)
});